// store/index.js
import { createStore } from 'vuex';
import auth from './auth';
import filter from './filter';
import { getTodayForAPI } from '@/utils/dateUtil';

function getKoreaDate() {
  return getTodayForAPI();
}

const store = createStore({
  state: {
    selectedDate: getKoreaDate(),
    bondExpansionState: {},
  },
  mutations: {
    SET_SELECTED_DATE(state, date) {
      state.selectedDate = date;
    },
    SET_BOND_EXPANSION_STATE(state, { bondId, isExpanded }) {
      state.bondExpansionState = {
        ...state.bondExpansionState,
        [bondId]: isExpanded,
      };
    },
    SET_ALL_BONDS_EXPANSION_STATE(state, isExpanded) {
      Object.keys(state.bondExpansionState).forEach(bondId => {
        state.bondExpansionState[bondId] = isExpanded;
      });
    },
    INITIALIZE_BOND_EXPANSION_STATE(state, bonds) {
      const savedState =
        JSON.parse(localStorage.getItem('bondExpansionState')) || {};
      state.bondExpansionState = bonds.reduce((acc, bond) => {
        acc[bond.id] =
          savedState[bond.id] !== undefined ? savedState[bond.id] : true;
        return acc;
      }, {});
    },
  },
  actions: {
    setSelectedDate({ commit }, date) {
      commit('SET_SELECTED_DATE', date);
    },
    initializeSelectedDate({ commit }) {
      commit('SET_SELECTED_DATE', getKoreaDate());
    },
    setBondExpansionState({ commit, state }, { bondId, isExpanded }) {
      commit('SET_BOND_EXPANSION_STATE', { bondId, isExpanded });
      localStorage.setItem(
        'bondExpansionState',
        JSON.stringify(state.bondExpansionState)
      );
    },
    setAllBondsExpansionState({ commit, state }, isExpanded) {
      commit('SET_ALL_BONDS_EXPANSION_STATE', isExpanded);
      localStorage.setItem(
        'bondExpansionState',
        JSON.stringify(state.bondExpansionState)
      );
    },
    initializeBondExpansionState({ commit }, bonds) {
      commit('INITIALIZE_BOND_EXPANSION_STATE', bonds);
    },
  },
  getters: {
    selectedDate: state => state.selectedDate,
    bondExpansionState: state => state.bondExpansionState,
  },
  modules: {
    auth,
    filter,
  },
});

export default store;
